<template>
  <div class="o-card">
    <form @submit="TO_RESET_PASSWORD">
      <div class="u-margin-bottom">
        <router-link :to="{ name: 'app-start' }">
          <logo width="80"></logo>
        </router-link>
        <h6 class="u-margin-top u-color-primary">
          {{ $t("common.welcome") }},
        </h6>
        <h4>{{ getAppSettings.projectName }}</h4>
        <p class="u-font-size-small">
          <small> {{ $t("account.signIn.resetPasswordTitle") }}.. </small>
        </p>
      </div>
      <BaseInput
        mandatory
        :label="$t('account.signIn.password')"
        input-id="password"
        icon="ui-lock"
        type="password"
        :placeholder="$t('account.signIn.passwordPlaceholder')"
        block
        v-model="form.password"
      />
      <Button
        class="u-margin-top"
        :loading="getLoadingStatus"
        block
        variant="primary"
        type="submit"
      >
        {{ $t("account.signIn.resetPassword") }}
      </Button>
    </form>
  </div>
</template>

<script>
import BaseInput from "@base/Inputs/BaseInput.vue";
import Button from "@base/Button.vue";
import GeneralStore from "../../mixins/generalStore";
import { mapGetters } from "vuex";
import Logo from "../Shared/Sidebar/Logo.vue";
export default {
  mixins: [GeneralStore],
  components: {
    BaseInput,
    Button,
    Logo,
  },
  computed: {
    ...mapGetters(["getAppSettings"]),
  },
  data() {
    return {
      localStorageEmail: null,
      form: {
        password: "",
      },
    };
  },
  methods: {
    async TO_RESET_PASSWORD(e) {
      e.preventDefault();
      const response = await this.$store.dispatch("TO_RESET_PASSWORD", {
        password: this.form.password,
        token: this.$route.query.token,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("account.signIn.resetPasswordSuccess"),
          variant: "success",
          duration: 2500,
        });
        this.$router.push({ name: "app-start" });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
    },
  },
  created() {
    this.storeNamespace = "account";
  },
};
</script>

<style></style>
